import linkedin from "../images/linkedinInvis.png";
import Bitcoin from "../images/andre-francois-mckenzie.jpg";
import photo from "../images/IMG_5064.JPG";
import { useState } from "react";
function Projects(){
const [linkedinImg, setBigShoeImg] = useState(linkedin);
const bitcoinImage = Bitcoin;
const width = window.innerWidth
const height = window.innerHeight
return(
        <>
        <div style={{minHeight:'500px' ,width:'100%' , justifyContent: "space-between"}} className={"flex-container-project-mobile flex-container"}>
        <div className ={"project-card-component project-card-mobile project-card testCard bg-gray-700  rounded-lg px-6 py-8 ring shadow-xl ring-gray-900/5"} style={{height: height/2*1.7,paddingRight:"30px" ,width:'28%', position: "relative" , borderRadius:'10px'}}>
        <div className="container">
        <div className="overlay">
            {/* <div class="popup">
            <h2>Popup Title</h2>
            <p>This is a hover-activated popup.</p>
            </div> */}
        </div>

        </div>
         <div style={{fontSize: "30px"}}className={"centerAlignContents"}> <p class="text-orange-700 font-bold">Press Release</p></div>
         <div style={{fontSize: "20px"}} className={"centerAlignContents"}> <p class="text-white font-bold">3 min read</p></div>
         <p class="hover-text project-font text-3xl text-white font-bold">Former Binance CEO Changpeng Zhao has joined the growing list of market pundits who believe Bitcoin price will top $500,000 this cycle before entering a bear market.</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-sm text-white font-bold">CZ’s comments came during a podcast interview with Rug Radio, during which he was asked where he thinks Bitcoin’s price tops at this cycle.</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-3xl text-white font-bold">Learn more</p>
         </div>
        <div className={'noHeight'} style={{paddingLeft:"40px", minHeight:"400px"}}></div>
         <div className ={"project-card-component project-card-mobile project-card testCard bg-gray-700  rounded-lg px-6 py-8 ring shadow-xl ring-gray-900/5"} style={{height: height/2*1.7 ,paddingRight:"30px" ,width:'28%',position: "relative", borderRadius:'10px'}}>
         <div className="container">
        <div className="overlay">
        </div>
        </div>
         <div style={{fontSize: "30px"}} className={"centerAlignContents"}> <p class="text-orange-700 font-bold">Press Release</p></div>
         <div style={{fontSize: "20px"}} className={"centerAlignContents"}> <p class="text-white font-bold">3 min read</p></div>
         <p class="project-card-text hover-text project-font text-3xl text-white font-bold">Bitcoin (BTC) is flashing strong bullish signals across macroeconomic and on-chain indicators,</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-sm text-white font-bold"> with analysts predicting a potential breakout to $135,000 within the next 100 days, provided current trends hold. At the core of this forecast are three key drivers: low market volatility, growing stablecoin liquidity, low market volatility, growing stablecoin liquidity, and a negative BTC funding rate setting up a possible short squeeze.</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-3xl text-white font-bold">Learn more</p>
       
         </div>
         <div className={'noHeight'} style={{paddingLeft:"40px", minHeight:"400px"}}></div>
         <div className ={"project-card-component project-card-mobile project-card testCard bg-gray-700  rounded-lg px-6 py-8 ring shadow-xl ring-gray-900/5"} style={{height: height/2*1.7, paddingRight:"30px" ,width:'28%',position: "relative", borderRadius:'10px'}}>
         <div className="container">
         <div className="overlay">

        </div>
        </div>
         <div style={{fontSize: "30px"}} className={"centerAlignContents"}> <p class="text-orange-700 font-bold">Press Release</p></div>
         <div style={{fontSize: "20px"}} className={"centerAlignContents"}> <p class="text-white font-bold">3 min read</p></div>
         <p class="project-font text-3xl text-white font-bold">Bitcoin, the first and largest cryptocurrency, may be gearing up for its next major move as a key Bitcoin indicator has hit a key reset level.</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-sm text-white font-bold">Other indicators suggest that Bitcoin may be on the verge of a significant move. The Bitcoin percentage supply in profit metric has also rebounded from its long-term mean, indicating a broad reset of investor expectations without widespread capitulation.</p>
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-3xl text-white font-bold">Learn more</p>
       
         </div>

        </div>
        <div style={{width:'100%' , paddingTop: '40px'}}></div>
         <div style={{width:'100%' ,height:'300px'}}class="project-font bg-gray-500 h-20 rounded-md 
            border-4 p-6 text-black background_gradient_project">
       
         <p style={{paddingTop:"20px"}} class="hover-text project-font text-3xl text-white font-bold">Learn more about finding your </p>
         <p style={{paddingTop:"20px", paddingBottom:"20px"}} class="hover-text project-font text-3xl text-white font-bold">transactions in the block chain</p>

        <div className={'flex-container'}>
        <a href="https://www.linkedin.com/in/leon-sia-7885ba357/" target="_blank">
        <img
          style={{zIndex:9}}
          src={linkedinImg}
          alt='shoe colletion'
          width={60}
          height={62}
          className='rotate-on-hover object-contain relative z-10'
        />
        </a>
        {/* <img
          style={{zIndex:9, borderRadius: "10px"}}
          src={photo}
          alt='shoe colletion'
          width={100}
          height={100}
        //   onMouseEnter={handleMouseEnter}
        //   onMouseLeave={handleMouseLeave}
          className='pic-resize rotate-on-hover object-contain relative z-10'
        /> */}

        </div>

        </div>
        </>

)
}

export default Projects